export const documentList = (state) => state.documentList;

export const loadingDocuments = (state) => state.loadingDocuments;
